import React, { Component } from 'react';
import { getToken } from '../../functions/app_functions.js';


export default class Logs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logs: []
        };

        // Define class methods
        this.loadLogData = this.loadLogData.bind(this);
    }


    componentDidMount() {
        if (this.state.logs.length <= 0) {
            this.loadLogData();
        }
    }


    async loadLogData() {
        try {
            // Send request
            var response = await fetch(this.props.baseUrl + "/getlogs", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                }
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data.length >= 1) {
                // Set data to state
                this.setState({
                    logs: data.reverse().slice(0, 50)
                });
            } else {
                // Track error
                var name = "Server error";
                var message = "Could not log data. Please check the URL and try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not log data. Please check the URL and try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Logs_LoadData");
        }
    }



    render() {

        return (
            <div className="content-container">
                <div className="content-wrapper">

                    {this.state.logs.map((log, i) => (
                        <div key={i} className="">
                            {log.error &&
                                (log.function + " | " + log.error + " | " + log.timestamp)
                            }

                            {!log.error &&
                                (log)
                            }
                        </div>
                    ))}

                </div>
            </div >
        )
    }
}